import { ref } from "vue";
import ResponseService from "@/_services/response.service";

const result = ref({ Success: false, Data: null });
const routePrefix = ref("logo/price/");

const sales_price_list_popup = async (code) => {

    const { get, responseResult } = ResponseService();

    await get(routePrefix.value + "sales-price-list-popup?code=" + code);

    if (responseResult.value) {
        if (responseResult.value.Messages.filter(x => x.MessageId == 1).length > 0) {
            result.value.Success = true;
            result.value.Data = responseResult.value.Data;
        }
        else
            result.value.Success = false;
    }
}


const PriceService = () => {
    return { sales_price_list_popup, result }
}

export default PriceService